import 'twin.macro'
import { IMAGE_LARGE_WIDTH_HEIGHT } from '../../const'
import FullWidthTextSection from '../FullWidthTextSection'
import Heading from '../Heading'
import Img from '../Img'
import type { TSinglePageHeroProps } from './interface'

export const SinglePageHero = (props: TSinglePageHeroProps) => {
  const { title, children, imgSrc, imgAlt, imgSizes, textCentering = 'left', bgPattern } = props

  return (
    <div tw="flex-col w-full justify-center items-center text-white">
      <FullWidthTextSection
        tw="p-14 w-1/3"
        colorTheme="#10163B"
        minHeight="400px"
        xAlign={textCentering}
        yAlign="bottom"
        patternPosition="right"
        bgPattern={bgPattern}
      >
        <Heading as="h1" variant="h1" tw="uppercase">
          {title}
        </Heading>
        {children}
      </FullWidthTextSection>
      {imgSrc && (
        <Img
          tw="w-full h-auto lg:h-[70vh] object-cover"
          src={imgSrc}
          alt={imgAlt ?? ''}
          width={IMAGE_LARGE_WIDTH_HEIGHT}
          height={IMAGE_LARGE_WIDTH_HEIGHT}
          sizes={imgSizes}
        />
      )}
    </div>
  )
}

export default SinglePageHero
